/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
// axios
import axios from "../axios.js";
// Router
import router from "../router.js";

import store from "./store.js";

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////
// Tocken
  userToken ({commit}, payload) {
    commit('SET_USER_TOKEN', payload)
  },
  removeToken ({commit}) {
    commit('REMOVE_TOKEN')
  },
  // Vertical NavMenu
  updateVerticalNavMenuWidth ({commit}, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({commit}, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({commit}, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({commit}, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({commit}) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({commit}, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo ({commit}, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
  // Custom api calling

  getPendingSubAppl: async ({ commit}, payload ) => {
    try {
      await axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/pendingSubmission/${payload}`).then(response => {
        console.log("pending submmission",response.data)
          commit("SET_PENDING_SUB_APPL", response.data);
      });
    } catch (e) {

    }
  },

  getSubmittedAppl: async ({ commit}, payload ) => {
    try {
      await axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/submittedApplication/${payload}`).then(response => {
        console.log("submmission",response.data)
          commit("SET_SUBMITTED_APPL", response.data);

      });
    } catch (e) {

    }
  },

  getChangeReqApplLists: async ({ commit}, payload ) => {
    try {
      console.log("pay", payload)
      await axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/getAllChangeRequestByStatus/${payload}`).then(response => {
        console.log("submmission",response.data)
          commit("SET_CHANGE_REQ_APPL", response.data);

      });
    } catch (e) {

    }
  },
  getApplication: async ({ commit }, payload) => {
    /*await commit("SET_LOADING", true);*/
    try {
      await axios
        .get(`https://ho.butterflygroupbd.com/bml-ha/proxy?url_path=application/${payload}`)
        .then(response => {
          commit("SET_APPLICATION", response.data);
          /*commit("SET_LOADING", false);*/
        });
    } catch (e) {
      /*commit("SET_LOADING", false);*/
    }
  },
  uploadExcel: async ({ commit }, payload) => {
    commit('SET_EXCEL_UPLOAD_LOADING', true);
    console.log('PostExcel file payload= ', payload);
    try {
      await axios
        .post('https://ho.butterflygroupbd.com/showroom-backend/api/importExcel', payload)
        // .post('http://showroom.test:82/api/importExcel', payload)
        .then((res) => {
          console.log('PostExcel file = ', res.data);
          commit('SET_COMPARE_DATA', res.data);
          commit('SET_EXCEL_UPLOAD_LOADING', false);
          commit('SET_EXCEL_UPLOAD_DONE', true)
        })
    } catch (e) {
      console.log('Error = ', e);
      //commit('SET_LOADING', false)
    }
  },
  compareDataForExcel: async ({ commit }) => {
    commit('SET_COMPARE_EXCEL_LOADING', true);
    try {
      await axios
        .get('https://ho.butterflygroupbd.com/showroom-backend/api/allCompare')
        .then((res) => {
          console.log('res.data => ', res.data);
          //commit('SET_COMPARE_DATA', res.data)
          commit('SET_COMPARE_EXCEL_LOADING', false);
          commit('SET_COMPARE_EXCEL_DONE', true);
          commit('SET_EXCEL_UPLOAD_LOADING', false);
          commit('SET_EXCEL_UPLOAD_DONE', false)
        })
    } catch (e) {
      //commit('SET_LOADING', false)
    }
  },
  getAllCompareList: async ({ commit }, payload) => {
    console.log('----------', payload)
    try {
      await axios
        .get(`https://ho.butterflygroupbd.com/showroom-backend/api/allCompareDataList?page=${payload}`)
        .then((res) => {
          console.log('res.data => ', res.data)
          commit('SET_COMPARE_DATA', res.data)
          //commit("SET_LOADING", false);
        })
    } catch (e) {
      //commit('SET_LOADING', false)
    }
  },
}

export default actions
